import { createFileRoute } from '@tanstack/react-router'

import { ContactConsentsPage } from '#/modules/communication/contact-consents-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/contact-consents')({
  component: ContactConsentsPage,
  validateSearch: validateListSearch,
})
